<template>
  <div class="no-margin-bottom">
    <b-field :name="field.product_data_column">
      <template v-slot:label>
        <span v-html="field.field_name"></span>
        <span v-if="field.mandatory" class="has-text-danger">*</span>
      </template>

      <!-- Text Input -->
      <b-input
        v-if="field.field_type === 'Text'"
        :value="formData[field.product_data_column]"
        @input="handleInput"
        maxlength="30"
        placeholder="Please select"
      />

      <!-- Number Input -->
      <b-input
        v-else-if="field.field_type === 'Number'"
        :value="formData[field.product_data_column]"
        @input="handleInput"
        type="number"
        maxlength="30"
        placeholder="Please select"
        class="cdf-edit-add-padding"
      />

      <!-- Number Range Input -->
      <b-input
        v-else-if="field.field_type === 'Number-range'"
        :value="formData[field.product_data_column]"
        @input="handleInput"
        type="number"
        maxlength="30"
        placeholder="Please select"
        class="cdf-edit-add-padding"
      />

      <!-- Date Picker -->
      <b-datepicker
        v-else-if="field.field_type === 'Date'"
        :name="field.product_data_column"
        :value="formData[field.product_data_column]"
        @input="handleInput"
        placeholder="Please select"
        icon="calendar-today"
        class="cdf-edit-add-padding cdf-edit-date-picker"
      />

      <!-- Dropdown -->
      <b-select
        v-else-if="field.field_type === 'Dropdown'"
        :value="getSelectedDropdownValue()"
        @input="handleDropdownChange"
        placeholder="Please select"
        class="cdf-edit-add-padding cdf-edit-select"
      >
        <option
          v-for="(option, index) in dropdownOptions"
          :key="index"
          :value="option"
          :title="option.name"
        >
          {{ option.name }}
        </option>
      </b-select>

      <!-- Validation Error -->
      <p v-if="validationError" class="help is-danger">
        {{ validationError }}
      </p>
    </b-field>
  </div>
</template>

<script>
const DROPDOWN_LABELS = {
  product_group: "Select Product Group",
  product_family: "Select Product Family",
  material_general: "Select Material General",
  material_detail: "Select Material Detail",
  chemistry: "Select Chemistry",
  packaging_type: "Select Packaging Type"
};

export default {
  name: "FormField",
  props: {
    field: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    dropdownOptions: {
      type: Array,
      default: () => []
    },
    validationError: {
      type: String,
      default: ""
    }
  },
  computed: {
    getDropdownPlaceholder() {
      return DROPDOWN_LABELS[this.field.product_data_column] || "Select ...";
    }
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
    handleDropdownChange(value) {
      this.$emit("input", value);
      this.$emit("dropdown-change", value);
    },
    getSelectedDropdownValue() {
      const currentValue = this.formData[this.field.product_data_column];

      // If the value is already an object with 'name' property, return it
      if (
        currentValue &&
        typeof currentValue === "object" &&
        currentValue.name
      ) {
        return currentValue;
      }

      // If the value is a string, try to find the matching option object
      if (currentValue && typeof currentValue === "string") {
        const matchingOption = this.dropdownOptions.find(
          opt => opt.name === currentValue
        );
        return matchingOption || currentValue;
      }

      // Return the value as-is (null, undefined, or empty string)
      return currentValue;
    }
  }
};
</script>

<style scoped>
.no-margin-bottom {
  margin-bottom: 0.75rem;
}

.cdf-edit-add-padding {
  width: 100%;
}

.cdf-edit-select,
.cdf-edit-date-picker {
  width: 100%;
}
</style>
